import { render, staticRenderFns } from "./keywordCategory.vue?vue&type=template&id=5f2e21c9&scoped=true"
import script from "./keywordCategory.vue?vue&type=script&lang=js"
export * from "./keywordCategory.vue?vue&type=script&lang=js"
import style0 from "./keywordCategory.vue?vue&type=style&index=0&id=5f2e21c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2e21c9",
  null
  
)

export default component.exports